import { render, staticRenderFns } from "./VetApplication.vue?vue&type=template&id=33971b66&"
import script from "./VetApplication.vue?vue&type=script&lang=js&"
export * from "./VetApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports